"use client";

import React from "react";
import { NextIntlClientProvider } from "next-intl";
import { defaultLocale } from "./locales";
import HtmlLangUpdater from "@/components/common/HtmlLangUpdater";
import embedMessages from "@/messages/en/embed.json";

/**
 * Lightweight i18n for App Router embed / player-error surfaces.
 *
 * Must not import AuthContext / firebaseConfig or all-locale message trees —
 * those belong on Pages `_app` via I18nProvider. English player + billing /
 * dub-preview strings are enough for public playback UI.
 *
 * Messages live in `messages/en/embed.json` (not the full pages/common trees)
 * so the embed client chunk stays small.
 */
export default function EmbedI18nProvider({
  children
}: {
  children: React.ReactNode;
}) {
  return <NextIntlClientProvider locale={defaultLocale} messages={embedMessages} onError={error => {
    if (error.code === "MISSING_MESSAGE" || error.code === "ENVIRONMENT_FALLBACK") {
      return;
    }
    console.error(error);
  }} data-sentry-element="NextIntlClientProvider" data-sentry-component="EmbedI18nProvider" data-sentry-source-file="EmbedI18nProvider.tsx">
      <HtmlLangUpdater data-sentry-element="HtmlLangUpdater" data-sentry-source-file="EmbedI18nProvider.tsx" />
      {children}
    </NextIntlClientProvider>;
}